// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'calendar-solid';

export const Component = () => (
  <path d='M24.5 3.857v3.841H.5v-3.84c0-.235.094-.47.281-.656a.927.927 0 0 1 .656-.282h4.828V1.468c0-.327.141-.468.47-.468.327 0 .468.14.468.468V2.92h10.593V1.468c0-.327.141-.468.47-.468.327 0 .468.14.468.468V2.92h4.828c.234 0 .469.094.656.282a.925.925 0 0 1 .281.655h.001ZM.5 23.063V8.682h24v14.381a.925.925 0 0 1-.281.656.927.927 0 0 1-.656.281H1.437a.927.927 0 0 1-.656-.281.925.925 0 0 1-.281-.656ZM17.797 11.54v1.92h1.922v-1.92h-1.922Zm-4.828 0v1.92h1.922v-1.92h-1.922Zm-2.86 4.825v1.92h1.922v-1.92h-1.922Zm-4.828 0v1.92h1.922v-1.92H5.28Z' />
);

export const viewBox = '0 0 25 25';
